import { render, staticRenderFns } from "./choiceChange.vue?vue&type=template&id=348bc1b9&scoped=true"
import script from "./choiceChange.vue?vue&type=script&lang=js"
export * from "./choiceChange.vue?vue&type=script&lang=js"
import style0 from "./choiceChange.vue?vue&type=style&index=0&id=348bc1b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348bc1b9",
  null
  
)

export default component.exports